<template>
	<section class="card card-mifid">
		<mifid-content :card="true" />

		<a
			v-if="!user.isCompany"
			:href="user.surveyPoolUrl"
			rel="noopener noreferrer nofollow"
			class="btn btn-primary mt-2 text-white"
		>
			wypełnienie ankiety
		</a>
	</section>
</template>

<script>
import MifidContent from '@/views/mifid/partial/_MifidContent';
import { mapGetters } from 'vuex';

export default {
	components: {
		MifidContent,
	},
	data() {
		return {
			// zmiana wyświetlania logowania w zalezności od tego na jakiej domenie jest user - wartości powinny być takie jak zwraca API
			/* eslint-disable */
			domains: {
				mbankHost: MBANK_HOST,
				mforexHost: MFOREX_HOST,
			},
		};
	},
	computed: {
		user() {
			return this.$store.getters.getUser
				? this.$store.getters.getUser
				: false;
		},
		...mapGetters(['getHost', 'getMifidUrl']),
	},
};
</script>
